import { IClusterRepository } from './IClusterRepository';
import { FakeRepository } from '../base/FakeRepository';
import { RemoteCluster } from '../../../../models/RemoteCluster';
import { Observable, of } from 'rxjs';

export class FakeClusterRepository extends FakeRepository<RemoteCluster> implements IClusterRepository {
  constructor() {
    super([]);
  }

  setClusters(wallboxId: string, clusters: RemoteCluster[]): Promise<void> {
    throw new Error('Method not implemented.');
  }

  readClusters(wallboxId: string): Observable<RemoteCluster[]> {
    return of([]);
  }
}
